/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const EyeOpenCrossedFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M20.7071 5.70711C21.0976 5.31658 21.0976 4.68342 20.7071 4.29289C20.3166 3.90237 19.6834 3.90237 19.2929 4.29289L17.7957 5.79008C16.1392 4.66048 14.145 4 12 4C7.42085 4 3.54819 7.00172 2.13978 11.1529C1.95341 11.7022 1.95341 12.2978 2.13978 12.8471C2.82312 14.8612 4.0842 16.6019 5.72386 17.8619L4.29289 19.2929C3.90237 19.6834 3.90237 20.3166 4.29289 20.7071C4.68342 21.0976 5.31658 21.0976 5.70711 20.7071L20.7071 5.70711ZM7.15304 16.4327L8.97194 14.6139C7.61258 13.0424 7.67913 10.664 9.17157 9.17157C10.664 7.67912 13.0424 7.61258 14.6139 8.97193L16.3503 7.2355C15.0795 6.45042 13.5914 6 12 6C8.32525 6 5.18238 8.40993 4.03374 11.7954C3.98875 11.928 3.98875 12.072 4.03374 12.2046C4.61871 13.9287 5.72349 15.4029 7.15304 16.4327ZM13.1921 10.3937C12.409 9.81107 11.2965 9.87508 10.5858 10.5858C9.87509 11.2965 9.81108 12.409 10.3937 13.192L13.1921 10.3937ZM19.2685 8.41076C19.7291 8.10599 20.3495 8.2323 20.6543 8.69288C21.1548 9.4493 21.5624 10.275 21.8602 11.1529C22.0466 11.7022 22.0466 12.2978 21.8602 12.8472C20.4518 16.9983 16.5791 20 12 20C11.3062 20 10.6272 19.9308 9.96974 19.7986C9.42829 19.6898 9.07762 19.1626 9.18649 18.6211C9.29537 18.0797 9.82256 17.729 10.364 17.8379C10.8925 17.9442 11.4394 18 12 18C15.6748 18 18.8176 15.5901 19.9663 12.2046C20.0112 12.072 20.0112 11.928 19.9663 11.7954C19.7242 11.082 19.393 10.4111 18.9864 9.79655C18.6816 9.33597 18.8079 8.71553 19.2685 8.41076Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </Icon>
  );
});

export { EyeOpenCrossedFillIcon };
